import { frNav } from './jewelryDictionary.nav';
import { frCore } from './jewelryDictionary.core';
import { frSales } from './jewelryDictionary.sales';

/** French translations for the Jewelry & Vault module (merged from per-area files). */
export const jewelryFallbacks: Record<string, Record<string, string>> = {
  fr: { ...frNav, ...frCore, ...frSales },
};
